// Loads the enhanced ecommerce pluggin inside GA required to used the encanced commands

window.addEventListener("DOMContentLoaded",
    function () {
        setTimeout(function() {
            if (typeof ga !== "undefined") {
                ga("require", "ec");
            }
        }, 500);
    });

